import React from 'react';
import './QuienesSomos.css';

const QuienesSomos: React.FC = () => {
  return (
    <div className="quienes-somos">
      <section className="page-hero">
        <div className="page-hero-content">
          <h1>¿Quiénes Somos?</h1>
          <p>Conoce nuestra historia, misión y el equipo que trabaja por el desarrollo territorial</p>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="content-grid">
            <div className="content-text">
              <p>
                Somos la Fundación para la Planeación y el Desarrollo Territorial - FUNDETER,
                una entidad sin ánimo de lucro con sede en Santa Marta - Magdalena, con más de
                12 años de trayectoria institucional.
              </p>
              <p>
                Contamos con un equipo profesional altamente calificado en ingeniería, gerencia
                de proyectos y planeación estratégica, con experiencia comprobada en la asesoría
                a entidades estatales y privadas.
              </p>
            </div>
            <div className="content-image">
              <div className="ods-split-grid" aria-label="Objetivos de Desarrollo Sostenible">
                <img
                  src="/ODS-cast-3x3-1.webp"
                  alt="Objetivos de Desarrollo Sostenible, bloque izquierdo"
                  loading="lazy"
                  decoding="async"
                />
                <img
                  src="/ODS-cast-3x3-2.webp"
                  alt="Objetivos de Desarrollo Sostenible, bloque derecho"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mission-vision empty-card-section">
        <div className="container">
          <div className="mission-vision-grid">
            <div className="vision-card empty-info-card">
              <h3>Propósito</h3>
              <p className="empty-info-copy empty-info-copy-italic">
                En FUNDETER contribuimos al alcance de los ODS:
              </p>
              <p className="empty-info-copy">
                Asesoramos a entidades públicas y privadas en el ciclo completo de proyectos de inversión, impulsando el desarrollo territorial con impacto social, sostenibilidad y eficiencia.
              </p>
              <p className="empty-info-copy">
                Conectamos la planeación con la acción, generando rutas estratégicas que transforman territorios de manera responsable, sostenible y con sentido social.
              </p>
            </div>
            <div className="mission-card empty-info-card">
              <img
                className="ceo-original-image"
                src="/CEO_original2.jpg"
                alt="Equipo FUNDETER"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="mission-vision">
        <div className="container">
          <div className="mission-vision-grid">
            <div className="mission-card">
              <h3>Misión</h3>
              <p>
                Nuestra misión es asesorar a entidades públicas y organizaciones privadas en la
                formulación, gestión, administración, ejecución, seguimiento y evaluación de
                proyectos de inversión pública y privada, con un enfoque estratégico orientado
                a generar impactos sostenibles, transformadores y con sentido social en los
                territorios, mediante el uso eficiente de recursos nacionales e internacionales.
              </p>
            </div>
            <div className="vision-card">
              <h3>Visión</h3>
              <p>
                Posicionarnos a nivel nacional e internacional como aliados estratégicos de
                entidades públicas y privadas, liderando la gestión y ejecución de planes y
                proyectos de inversión que transformen social y sosteniblemente los territorios.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="object-section">
        <div className="container">
          <div className="object-card">
            <h2>Objeto</h2>
            <div className="object-content">
              <p>
                Asesorar en la formulación, administración, seguimiento y evaluación de proyectos de inversión pública y privada a entidades del Estado, territoriales, así como a entidades privadas y mixtas en temas como investigación, ciencia, tecnología e innovación, planificación y desarrollo con el fin de aprovechar y canalizar recursos a nivel nacional e internacional para el desarrollo de las regiones. Orientar a los entes territoriales para gestionar recursos del Sistema General de Regalías para generar resultados de alto impacto. Difundir conocimiento acerca de metodologías para la estructuración de proyectos, programas y planes.
              </p>
              <p>
                Ejecución de obras civiles y proyectos de infraestructura exclusivamente cuando estas se desarrollen en el marco del cumplimiento del objeto social meritorio y en desarrollo de convenios, contratos o alianzas relacionadas con el desarrollo social, territorial, ambiental y educativo.
              </p>
              <p>
                Establecer alianzas, convenios y relaciones de cooperación con entidades y
                dependencias del orden nacional, departamental, distrital y municipal con el fin
                de apoyar la formulación, gestión, administración, ejecución, seguimiento y
                evaluación de planes, programas y proyectos en áreas como:
              </p>
              <div className="areas-grid">
                <div className="area-item">• Planeación territorial</div>
                <div className="area-item">• Gobierno y desarrollo social</div>
                <div className="area-item">• Economía popular</div>
                <div className="area-item">• Desarrollo económico</div>
                <div className="area-item">• Inclusión, equidad y género</div>
                <div className="area-item">• Transporte y movilidad</div>
                <div className="area-item">• Servicios públicos</div>
                <div className="area-item">• Educación y salud</div>
                <div className="area-item">• Riesgo climático y medio ambiente</div>
                <div className="area-item">• Tecnologías de la información (TIC)</div>
                <div className="area-item">• Fortalecimiento institucional</div>
                <div className="area-item">• Participación ciudadana</div>
                <div className="area-item">• Cultura, recreación y deporte</div>
                <div className="area-item">• Ejecución de obras civiles</div>
                <div className="area-item">• Proyectos de infraestructura</div>
              </div>
              <p className="object-conclusion">
                Contribuyendo así al cumplimiento de los planes de desarrollo territoriales y a
                la transformación integral de los territorios en infraestructuras tecnológicas
                y civiles.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="values">
        <div className="container">
          <h2>Principios de la Organización</h2>
          <div className="values-grid">
            <div className="value-item">
              <h4>Compromiso Social</h4>
              <p>Trabajamos con y para las comunidades, priorizando siempre el bienestar colectivo.</p>
            </div>
            <div className="value-item">
              <h4>Transparencia</h4>
              <p>Actuamos con honestidad y claridad en todos nuestros procesos y relaciones.</p>
            </div>
            <div className="value-item">
              <h4>Excelencia Técnica</h4>
              <p>Contamos con profesionales altamente calificados en ingeniería y gerencia de proyectos.</p>
            </div>
            <div className="value-item">
              <h4>Sostenibilidad</h4>
              <p>Promovemos soluciones que generen impactos duraderos y respeten el medio ambiente.</p>
            </div>
            <div className="value-item">
              <h4>Innovación</h4>
              <p>Aplicamos metodologías innovadoras y tecnologías apropiadas para cada contexto.</p>
            </div>
            <div className="value-item">
              <h4>Eficiencia</h4>
              <p>Optimizamos el uso de recursos nacionales e internacionales para maximizar el impacto.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="quienes-projects-cta">
        <div className="container">
          <a href="/proyectos" className="cta-button secondary">Ver nuestros proyectos</a>
        </div>
      </section>

      <section className="quienes-footer-bottom">
        <div className="container home-footer-bottom-content">
          <div className="home-footer-col">
            <h4>FUNDETER-ORG</h4>
            <p>
              Somos una entidad sin ánimo de lucro con sede en Santa Marta - Magdalena, con más de 12 años de trayectoria institucional. Planeamos y transformamos territorios con sentido social.
            </p>
          </div>
          <div className="home-footer-col">
            <h4>Información de contacto</h4>
            <p>✉️ info@fundeter.org</p>
            <p>📲+57 313 744 9160</p>
            <p>📍 Carrera 66 # 48 - 106 Casa M3 Urbanización San Lorenzo, Santa Marta D.T.C.H. - Colombia.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default QuienesSomos;



